<template>
  <f7-page id="reg-verify-email" name="reg-verify-email" class="mb-xxl" @page:afterin="afterin">
    <div class="block">
      <div class="wandr-title-1 text-align-center mt-xxl">{{$t('regis-verify-email')}}</div>
      <div class="text-align-center mt-md">
        <div><img :src="require('@/assets/img/icon/icon-email.svg')" style="" /></div>
      </div>

      <div class="wandr-subtitle-1 text-align-center mt-md">
        {{$t('regis-verify-email-text')}}
      </div>
    </div>

    <f7-toolbar position="bottom" no-hairline class="toolbar-with-button">
      <f7-button large fill @click="goToNextPage" :disabled="!isNextButtonValid">
          {{$t('label-common-next')}}
      </f7-button>
    </f7-toolbar>
  </f7-page>
</template>

<script>
  export default {
    mounted (){
      if(window.Android || window.webkit) {
        this.showPreloader();
        this.checkBiometryAvaibility();
        this.$root.$once("handleBiometryType", (type) => {
          // 0 = None, 1 = Fingerprint, 2 = Face ID
          this.biometryType = type;
          this.hidePreloader();
        });
      }
    },
    data() {
      return {
        isNextButtonValid   : true,
        biometryType        : 0
      };
    },
    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      goToNextPage(){
        this.showPreloader();
        if(this.biometryType != 0) {
          console.log("go to : activate biometry")
          this.$f7router.navigate("/register-activate-biometry", { props: { biometryType: this.biometryType }});
        } else {
          console.log("go to : home")
          this.$f7router.navigate("/home");
        }
        this.hidePreloader();
      }
    },
    components: {

    },
    computed: {

    },
  }
</script>